/**
*
*   Accordion
*       - Accordion Dropdown
*
**/
'use client';
import { useState } from 'react';


//Build the Collection
export default function SafetyAccordion({ children , option , ...props }){

	const [ open , setOpen ] = useState(false);

	return (
		<li className={ open ? 'open' : '' }>
			<div className="dropdown" onClick={ () => setOpen( !open ) }>
				<p>{ option.name }</p>
				<svg xmlns="http://www.w3.org/2000/svg" width="15" height="8" viewBox="0 0 15 8" fill="none">
					<path d="M14 1L7.5 7L1 0.999999" stroke="currentcolor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
				</svg>
			</div>
			<ol>
				{ children }
			</ol>
		</li>
	);

}